/*
      ___           ___
     /\  \         /\  \
    /::\  \       /::\  \
   /:/\:\  \     /:/\ \  \
  /::\ \:\  \   _\:\ \ \  \
 /:/\:\ \:\__\ /\ \:\ \ \__\
 \/_|::\/:/  / \:\ \:\ \/__/
    |:|::/  /   \:\ \:\__\
    |:|\/__/     \:\/:/  /
    |:|  |        \::/  /
     \|__|         \/__/

    Developed by Ralph Shippam - 2019.
*/

import {Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {WindowRef} from './windowref';
import {RSLoadingModalIconAnimation, RSLoadingModalSpinner} from './rsloading.modal.defaults';
import {RSDialogComponentModel} from '../rsnotify/rsdialog.component.model';
import {ThemePalette} from '@angular/material/core';

@Component({
    selector: 'rs-loading-modal',
    templateUrl: 'rsloading.modal.component.html',
    styleUrls: ['rsloading.modal.component.scss'],
    exportAs: 'RSloadingModalComponent',
})
export class RSloadingModalComponent extends RSDialogComponentModel implements OnDestroy {

    displayType$: RSLoadingModalSpinner;
    displayTypes$ = RSLoadingModalSpinner;
    displayConfig: any = {}; // TODO: TYPESET
    iconAnimationTypes$ = RSLoadingModalIconAnimation;

    constructor() {
        super();

        this.dialogValuesUpdated.subscribe(() => {
            this.displayType$ = this.dialogValues.type || RSLoadingModalSpinner.MatSpinner;
            this.displayConfig = this.dialogValues; // TODO: TYPESET
        });
    }

    getSingleColor(color: ThemePalette | ThemePalette[]) {
        if (Array.isArray(color)) {
            if (color.length > 0) {
                return color[0] || 'primary';
            } else {
                return 'primary';
            }
        } else {
            return color || 'primary';
        }
    }

    ngOnDestroy(): void {

    }
}


